import React, { useState } from "react";
import Welcome from "./components/Welcome";
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Resume from "./components/Resume";
import TechStack from "./components/TechStack";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import EasterEgg from "./components/EasterEgg";

function App() {
  const [showWelcome, setShowWelcome] = useState(true);

  const handleWelcomeFinish = () => {
    setShowWelcome(false);
  };

  useEffect(() => {
  AOS.init({
    duration: 1000, // animation duration in ms
    once: true,     // animation happens only once
  });
}, []);

  return (
    <>
      {showWelcome && <Welcome onFinish={handleWelcomeFinish} />}

      {!showWelcome && (
        <div className="font-sans text-gray-800">
          <EasterEgg />
          <Header />
          <Hero />
          <About />
          <TechStack />
          <Projects />
          < Resume />
          <Contact />
          <Footer />
        </div>
      )}
    </>
  );
}

export default App;
